import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getDefaultRoute } from "../../config/routing";
import FilledButton from "../../components/Buttons/FilledButton";

const Unauthorized = () => {

    const { officerProfile, officerPermissions } = useSelector((store) => {
        return {
            officerProfile: store.UserReducer.officerProfile,
            officerPermissions: store.UserReducer.officerPermissions,
        }
    });

    const navigate = useNavigate();

    return (
        <div 
            style={{
                height: "100vh", 
                display: "flex", 
                flexDirection: "column",
                justifyContent: "center", 
                alignItems: "center", 
                gap: 16
            }}
        >
            <h2>Access Denied</h2>
            <p>You don't have permission to view this page.</p>
            <FilledButton 
                title={"Go to Home"}
                handleClick={() => {
                    navigate(getDefaultRoute(officerPermissions))
                }}
            />
        </div>
    );
};

export default Unauthorized;